import { render, staticRenderFns } from "./v-serviced-progress.vue?vue&type=template&id=70e7b320&scoped=true&"
import script from "./v-serviced-progress.vue?vue&type=script&lang=js&"
export * from "./v-serviced-progress.vue?vue&type=script&lang=js&"
import style0 from "./v-serviced-progress.vue?vue&type=style&index=0&id=70e7b320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7b320",
  null
  
)

export default component.exports